export default __webpack_public_path__ + "assets/images/vector.e8380d.png";